import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X, CheckCircle2 } from 'lucide-react';
const NAMES = ['Martín G.', 'Laura P.', 'Diego M.', 'Carolina S.', 'Federico A.', 'Lucía R.', 'Sebastián V.', 'María F.', 'Joaquín D.', 'Sofía B.', 'Pablo C.', 'Valentina T.', 'Nicolás H.', 'Florencia L.', 'Matías O.', 'Agustina N.', 'Tomás I.', 'Camila E.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Juan', 'Paraná', 'Corrientes', 'Bariloche', 'Comodoro Rivadavia'];
const TIMES = ['hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 15 minutos', 'hace 20 minutos'];
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    let hideId: ReturnType<typeof setTimeout>;
    const show = () => {
      setData({
        name: pick(NAMES),
        city: pick(CITIES),
        time: pick(TIMES)
      });
      setVisible(true);
      hideId = setTimeout(() => setVisible(false), 6000);
      timeoutId = setTimeout(show, 14000);
    };
    timeoutId = setTimeout(show, 4000);
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(hideId);
    };
  }, []);
  return <AnimatePresence data-id="element-129">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-sm z-50 bg-white rounded-2xl shadow-2xl border border-slate-200 p-4 flex items-start gap-3" data-id="element-130">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-brand-green/10 flex items-center justify-center text-brand-green" data-id="element-131">
            <ShoppingBag size={20} data-id="element-132" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-133">
            <p className="text-sm font-bold text-brand-dark" data-id="element-134">
              {data.name} de {data.city}
            </p>
            <p className="text-xs text-slate-600 mt-0.5" data-id="element-135">
              acaba de comprar Triatlón en 6HS
            </p>
            <div className="flex items-center gap-1 mt-1" data-id="element-136">
              <CheckCircle2 size={12} className="text-brand-green" data-id="element-137" />
              <span className="text-xs text-slate-400" data-id="element-138">{data.time}</span>
            </div>
          </div>
          <button onClick={() => setVisible(false)} className="flex-shrink-0 text-slate-400 hover:text-slate-600 transition-colors" aria-label="Cerrar" data-id="element-139">
            <X size={16} data-id="element-140" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}